import InputNumberEditableField from 'src/components/fields/InputNumberEditableField/InputNumberEditableField';

export default InputNumberEditableField;
